import styled from "styled-components";

interface BodyResumoProps {
    naoQuebrarLinha?: boolean;
    width?: string;
}

export const ContainerBackground = styled.div`
    border-radius:10px;  
    margin: 32px 10px -30px 10px;
    padding: 20px;
    background-color: ${({ theme }) => theme.colors.neutral.neutral00};
`;

export const TituloDadoResumo = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const BodyDadoResumo = styled.div<BodyResumoProps>`
    font-weight: bold;
    ${(props) => props.naoQuebrarLinha ? "white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" : ""}
    ${(props) => props.width ? `width: ${props.width}` : ""}
`;